import React from "react";
import { PageHeader } from "../EditorChrome";
import { MediaGrid, UploadDropzone, useMediaLibrary } from "../MediaPickerModal";

export function MediaPage() {
  const { files, loading, uploading, upload, remove } = useMediaLibrary();

  return (
    <div className="lw-page">
      <PageHeader
        title="Media library"
        subtitle="Images uploaded through the CMS. Published builds mirror these onto the site automatically."
      />
      <UploadDropzone uploading={uploading} onFiles={upload} />
      {loading ? (
        <p className="lw-empty">Loading media…</p>
      ) : (
        <MediaGrid files={files} onDelete={remove} />
      )}
    </div>
  );
}
